import type { DocumentSigner } from '@api/types/document';
import { DocumentSignaturesStatus } from '@api/types/enums';

/**
 * A document is considered signed when it has signers and every one of them
 * has signed. Single source of truth for the "fully signed" derivation used
 * across the Documents page, the dashboard overview and the audit review flow.
 */
export const isDocumentSigned = (signers?: DocumentSigner[]): boolean =>
  !!signers?.length && signers.every((signer) => signer.status === DocumentSignaturesStatus.signed);
